<template lang="pug">
  #ChatRoomIndex.chatroom.h-100.overflow-hidden
    appHeader.py-3(
      :hasBackTool="true",
      :headerType="'title'",
      :title="chatRoomTitle"
    )
    .container-width.h-100.pt-0
      .chatroom__mainPart.content-body.h-100
        .content.p-2.h-100#chatAreaScroll(
          ref="chatAreaScroll"
        )
          infinite-loading(
            direction="top",
            :distance="10",
            @infinite="chatOnPullingDown",
            spinner="bubbles",
            ref="infiniteLoadingCom",
            :identifier="infiniteId"
          )
            div.cursor-default(slot="no-more") 無更多聊天記錄
            div.cursor-default(slot="no-results") 無更多聊天記錄
            div.cursor-default(slot="error") 發生錯誤，請重整重試一次
          components(
            v-for="(msg,index) in chatMessages",
            :key="`${msg.id}-${index}`",
            :is="watchMsgsType(msg)",
            :messageData="msg.messageData",
            :profile_picture="msg.profile_picture",
            v-if="watchMsgsType(msg) !== 'null'",
            :timeData="msg.time",
            @showLightBox="showLightBox"
          )
    .chatroom__footerPart
      ChatroomFooter.h-100(
        @sendHandler="sendHandler",
        :user="user"
      )

    SitckerModel(
      title="貼圖",
      @postSendApiHandler="postSendApiHandler",
      @closeModelHandler="setChatScroll"
    )

    TempModel(
      title="訊息模板",
      :user="this.user",
      @closeModelHandler="setChatScroll"
    )

    ReservationModel(
      title="顧客預約",
      :user="this.user",
      @postSendApiHandler="postSendApiHandler",
      @closeModelHandler="setChatScroll"
    )

    TagModel(
      title="顧客標籤",
      @closeModelHandler="setChatScroll"
    )

    InvitationModel(
      title="邀請函",
      :user="this.user",
      @closeModelHandler="setChatScroll"
    )

    //- lightBox
    vue-easy-lightbox(
      escDisabled
      moveDisabled
      :visible="lightBoxVisible"
      :imgs="lightBoxImg"
      @hide="lightBoxVisible = false"
    )
</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import JQuery from 'jquery';

import appHeader from '@/components/partials/AppHeader.vue';
import ChatroomFooter from '@/components/chat/ChatroomFooter.vue';
import SitckerModel from '@/components/customerModel/stickerModel.vue';
import TempModel from '@/components/customerModel/tempModel.vue';
import ReservationModel from '@/components/customerModel/reservationModel.vue';
import TagModel from '@/components/customerModel/tagModel.vue';
import TitleDate from '@/components/chat/system/TitleDate.vue';
import InvitationModel from '@/components/customerModel/invitationModel.vue';

// 顧客
import MText from '@/components/chat/member/M-Text.vue';
import MImg from '@/components/chat/member/M-Img.vue';
import MVideo from '@/components/chat/member/M-Video.vue';
import MSticker from '@/components/chat/member/M-Sticker.vue';

// 顧問
import PText from '@/components/chat/personnel/P-Text.vue';
import PImg from '@/components/chat/personnel/P-Img.vue';
import PVideo from '@/components/chat/personnel/P-Video.vue';
import PSticker from '@/components/chat/personnel/P-Sticker.vue';
import PImageMap from '@/components/chat/personnel/P-ImageMap.vue';
import PCarousel from '@/components/chat/personnel/P-Carousel.vue';

// websocket 監聽
import Echo from 'laravel-echo';

const moment = require('moment');
const _ = require('lodash');

const $ = JQuery;

export default {
  name: 'ChatRoomIndex',
  components: {
    InfiniteLoading,
    appHeader,
    ChatroomFooter,
    TempModel,
    SitckerModel,
    ReservationModel,
    TagModel,
    InvitationModel,
    TitleDate,
    MText,
    MImg,
    MVideo,
    MSticker,
    PText,
    PImg,
    PVideo,
    PSticker,
    PImageMap,
    PCarousel
  },
  props: {
    chatRoomTitle: {
      type: String,
      default: '發送訊息'
    },
    user: {
      type: [Object, null]
    },
    sa_id: {
      type: [String, Number],
      default: null
    }
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sa_chat/resetHandler');
    vm.$store.commit('toggleLoading', false);
    // 取得個人資料, 要先去拿這個顧問的 sa_id
    vm.$store.dispatch('sa_profile/getProfileHandler')
      .then(() => {
        vm.$swal.close();
      });
  },
  mounted() {
    const vm = this;
    if (vm.user && vm.sa_id) {
      window.io = require('socket.io-client');
      window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: process.env.VUE_APP_WEBSOCKET_URL,
        transports: ['websocket', 'polling', 'flashsocket'],
        auth: {
          headers: {
            Authorization: window.sessionStorage.getItem('data'),
            Source: 'one-to-one'
          }
        }
      });
      const channelName = `one_to_one_${vm.sa_id}_${process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID}_${vm.user.member_uuid || vm.user.member_line_uuid}`;
      window.Echo.private(channelName)
        .listen('.line.one-to-one-frontend', async (e) => {
          vm.$store.dispatch('sa_chat/readHandler', `${vm.user.member_uuid || vm.user.member_line_uuid}`);
          // 收到事件 e 為收到的 data
          await vm.receiveMessage(e);
          vm.setChatScroll();
        });
    }
  },
  data() {
    return {
      chatMessages: [], // 聊天記錄
      oldMessagePushArr: [], // 拿來放打 api 拿到的舊聊天記錄的陣列
      chatPaginationData: {
        current_page: 0,
        per_page: 10,
        total_page: null
      }, // 聊天記錄分頁
      infiniteId: +new Date(),
      isReceiveHandling: false, // 記錄是否正在處理接收訊息
      isGettingApiData: false, // 打api的狀態
      lightBoxVisible: false, // 圖片是否可以看見
      lightBoxImg: [], // 要放到 lightBox 的圖片
      isFirstLoad: true, // 第一次載入
      reservationMemberUuid: null // 預約者(顧客)的ID
    };
  },
  methods: {
    // 檢查型態
    watchMsgsType(msg) {
      // 顧客對顧問
      if (msg.direction === 'm2p') {
        if (msg.previewComponent === 'text') {
          return 'm-text';
        }
        if (msg.previewComponent === 'image') {
          return 'm-img';
        }
        if (msg.previewComponent === 'video') {
          return 'm-video';
        }
        if (msg.previewComponent === 'sticker') {
          return 'm-sticker';
        }
        return 'null';
      } if (msg.direction === 'p2m' || msg.direction === 's2m') {
        if (msg.previewComponent === 'text') {
          return 'p-text';
        }
        if (msg.previewComponent === 'image') {
          return 'p-img';
        }
        if (msg.previewComponent === 'video') {
          return 'p-video';
        }
        if (msg.previewComponent === 'sticker') {
          return 'p-sticker';
        }
        if (msg.previewComponent === 'imageMap') {
          return 'p-image-map';
        }
        if (msg.previewComponent === 'carousel') {
          return 'p-carousel';
        }
        return 'null';
      } if (msg.previewComponent === 'title_date') {
        return 'titleDate';
      }
        return 'null';
    },
    // 聊天欄位 上拉更新
    chatOnPullingDown($state) {
      const vm = this;
      // 如果是一對一再打 API 拿對話紀錄
      if (vm.user && vm.user !== undefined) {
        if (vm.isGettingApiData) return;
        vm.isGettingApiData = true;
        // 清空舊的聊天記錄陣列
        vm.oldMessagePushArr = [];

        // 打 api 去拿聊天紀錄
        this.$store.dispatch('sa_chat/getChatHandler', {
          member_uuid: `${vm.user.member_uuid || vm.user.member_line_uuid}`,
          current_page: vm.chatPaginationData.current_page + 1,
          per_page: vm.chatPaginationData.per_page
        }).then(() => {
          vm.$set(vm, 'chatPaginationData', vm.pagination);
          if (vm.pagination.current_page === 0 || vm.pagination.total_page === 0) {
            $state.complete();
          }

          // 判斷是否最後一頁的資料，讓塞資料時知道最上方是否要塞時間
          const isLastPage = vm.pagination.total_page === vm.pagination.current_page;

          // 取得對話紀錄 並 跑迴圈去整理資料(這邊需要非同步 不然會還沒跑完迴圈 就去抓時間 會抓不到)
          vm.setChatData(vm.datum)
            .then(() => {
              // 把舊陣列往現有陣列的上面塞 不能用 push
              vm.chatMessages = vm.oldMessagePushArr.concat(vm.chatMessages);
              // 更改打api狀態
              vm.isGettingApiData = false;
              // 判斷是否是最後一筆了
              if (isLastPage) {
                $state.complete();
                return;
              }
              $state.loaded();
            })
            .then(() => {
              if (vm.isFirstLoad) {
                // 聊天室置底
                vm.setChatScroll();
                vm.isFirstLoad = false;
              }
            });
        });
      } else {
        $state.complete();
      }
    },
    // 整理聊天內容
    setChatData(messages) {
      const vm = this;
      let data = null;
      return new Promise((resolve) => {
        _.forEach(messages, (val, index) => {
          // 插入一個時間的 components
          data = {
            previewComponent: 'title_date',
            time: val.send_at
          };
          // 把整理好的格式丟進陣列顯示出來
          vm.oldMessagePushArr.push(data);

          // 取得時間資料的年月日格式
          const send_at_date = moment(val.send_at).format('MM-DD-YYYY');

          // 上面檢查是否需要丟時間完成後繼續跑丟資料的程式碼
          // 整理成我們需要的格式
          data = {
            id: val.id,
            member_uuid: val.member_uuid,
            previewComponent: null,
            messageData: JSON.parse(val.message),
            is_read: val.is_read,
            direction: val.direction,
            profile_picture: val.direction === 'm2p' ? vm.user.picture_url : val.direction !== 'm2p' && vm.user ? vm.user.sa_picture : null
          };
          // 丟近時間進 messageData
          data.messageData.time = val.send_at;

          // 判斷是 user 傳送或是 host 傳送
          // m2p 為 user 傳送 => '會員to顧問'
          if (val.direction === 'm2p') {
            data.previewComponent = JSON.parse(val.message).type;
          } else {
            // 其餘都是 host 傳送
            // p2m => '顧問to會員', s2m => '系統to會員', s2p => '系統to顧問'
            // 先判斷是不是模板 (只有這邊傳給使用者會有模板)
            if (JSON.parse(val.message).type === 'template') {
              const templateData = JSON.parse(val.message).data;
              // 模板要一個一個塞回去
              _.forEach(templateData, (value) => {
                // 這個要放裡面 不然跑完迴圈都會抓到最後一筆
                const newData = {
                  id: _.cloneDeep(data.id),
                  member_uuid: _.cloneDeep(data.member_uuid),
                  previewComponent: value.type,
                  messageData: _.cloneDeep(value),
                  is_read: _.cloneDeep(val.is_read),
                  direction: data.direction,
                  profile_picture: val.direction === 'm2p' ? vm.user.picture_url : val.direction !== 'm2p' && vm.user ? vm.user.sa_picture : null
                };
                // 自己加入時間 (因為template裡的data沒有時間)
                newData.messageData.time = _.cloneDeep(val.send_at);
                // 把整理好的格式丟進陣列顯示出來
                vm.oldMessagePushArr.push(newData);
              });
              // 把 previewComponent 變回空才不會重複新增到
              data.previewComponent = null;
            } else {
              data.previewComponent = JSON.parse(val.message).type;
            }
          }
          // 這邊判斷 Component 是否是空的 如果前一個是 template 就可能為空
          // 把整理好的格式丟進陣列顯示出來
          if (data.previewComponent !== null) {
            vm.oldMessagePushArr.push(data);
          }
        });
        resolve();
      });
    },
    sendHandler(data) {
      const vm = this;
      if (!data || !data.type) return;

      switch (data.type) {
        case 'text':
          vm.postSendApiHandler(data);
          break;
        case 'image':
          vm.$swal.fire({
            title: '圖片上傳中，請稍候',
            allowOutsideClick: false,
            heightAuto: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });
          // 先上傳圖片, 之後再打 Post Chat Api
          vm.$store.dispatch('sa_chat/saveImgHandler', data.file.file)
            .then((res) => {
              if (res.length === 1) {
                vm.postSendApiHandler({
                  type: 'image',
                  file_id: res[0].data.file_id,
                  image: res[0].data.url
                });
              } else {
                vm.$swal.close();
              }
            });
          break;
        case 'video':
          vm.$swal.fire({
            title: '影片上傳中，請稍候',
            allowOutsideClick: false,
            heightAuto: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });
           // 先上傳影片, 之後再打 Post Chat Api
          vm.$store.dispatch('sa_chat/saveVideoHandler', data.file.file)
            .then((res) => {
              vm.$swal.close();
              if (res.length === 1) {
                vm.postSendApiHandler({
                  type: 'video',
                  video: res[0].data.url,
                  previewImage: res[0].data.previewImage
                });
              } else {
                vm.$swal.close();
              }
            });
          break;
        default:
          break;
      }
    },
    // 送出訊息
    postSendApiHandler(data) {
      const vm = this;
      // Loding
      vm.$swal.fire({
        title: '訊息送出中，請稍候',
        allowOutsideClick: false,
        heightAuto: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      vm.$store.dispatch('sa_chat/sendHandler', {
        member_uuid: `${vm.user.member_uuid || vm.user.member_line_uuid}`,
        ...data
      })
        .then(() => {
          vm.setChatScroll();
          vm.$swal.close();
        });
    },
    // 接收訊息
    receiveMessage(messageData) {
      const vm = this;
      return new Promise((resolve) => {
        let lastSendAt = null;
        if (vm.chatMessages.length !== 0) {
          // 上一則訊息的時間
          const lastMessage = vm.chatMessages[vm.chatMessages.length - 1];
          lastSendAt = moment(lastMessage.messageData.time).format('MM-DD-YYYY');
        }
        // 先判斷是不是同個年月日
        const sendAtDate = moment(messageData.send_at).format('MM-DD-YYYY');
        // data 用來放要塞進陣列的資料
        let data = null;

        // 這邊去判斷是否需要多塞一個時間的 components
        if (sendAtDate !== lastSendAt) {
          // 如果時間不同 插入一個時間的 components
          data = {
            previewComponent: 'titleDate',
            time: messageData.send_at
          };
          // 把整理好的格式丟進陣列顯示出來
          vm.chatMessages.push(data);
        }

        // 上面檢查是否需要丟時間完成後繼續跑丟資料的程式碼, 整理成我們需要的格式
        data = {
          id: messageData.id,
          member_uuid: messageData.line_uuid,
          previewComponent: null,
          messageData: {
            time: messageData.send_at,
            ...messageData.message
          },
          profile_picture: messageData.direction === 'm2p' ? vm.user.picture_url : messageData.direction !== 'm2p' && vm.user ? vm.user.sa_picture : null
        };

        // 判斷是 user 傳送或是 host 傳送
        // m2p 為 user 傳送 => '會員to顧問'
        if (messageData.direction === 'm2p') {
          data.direction = 'm2p';
          data.previewComponent = `${messageData.message.type}`;
        } else {
          // 其餘都是 host 傳送
          // p2m => '顧問to會員', s2m => '系統to會員', s2p => '系統to顧問'
          // 先判斷是不是模板
          if (messageData.message.type === 'template') {
            const templateData = JSON.parse(JSON.stringify(messageData.message)).data;

            // 模板要一個一個塞回去
            for (let i = 0; i < templateData.length; i++) {
              // 這個要放裡面 不然跑完迴圈都會抓到最後一筆
              const newData = {
                id: data.id,
                member_uuid: data.member_uuid,
                previewComponent: `host_${templateData[i].type}`,
                messageData: templateData[i]
              };
              // 自己加入時間 (因為template裡的data沒有時間)
              newData.messageData.time = messageData.send_at;
              // 把整理好的格式丟進陣列顯示出來
              vm.chatMessages.push(newData);
            }
            // 把 previewComponent 變回空才不會重複新增到
            data.previewComponent = null;
          } else {
            data.direction = 'p2m';
            data.previewComponent = `${messageData.message.type}`;
          }
        }
        // 這邊判斷 Component 是否是空的 如果前一個是 template 就可能為空 不是空在往聊天記錄陣列內丟
        if (data.previewComponent !== null) {
          // 把整理好的資料丟進去
          vm.chatMessages.push(data);
          // 聊天室置底
          vm.setChatScroll();
        }
        resolve();
        // 聊天室置底
        vm.setChatScroll();
      });
    },
    // 顯示幻燈片
    showLightBox(lightBoxMessageData) {
      const vm = this;
      // 先清空之前留下的圖片, 把要看的圖片放到幻燈片去, 打開幻燈片
      vm.lightBoxImg = [];
      vm.lightBoxImg = lightBoxMessageData;
      vm.lightBoxVisible = true;
    },
    // 聊天室置底
    setChatScroll() {
      $('#chatAreaScroll').animate({
        scrollTop: $('#chatAreaScroll').outerHeight() + 999999
      }, 500);
      setTimeout(() => {
        $('#chatAreaScroll').scrollTop = $('#chatAreaScroll').scrollHeight;
      }, 1000);
    }
  },
  computed: {
    ...mapState({
      datum: (state) => state.sa_chat.datum,
      pagination: (state) => state.sa_chat.pagination
    })
  },
  beforeDestroy() {
    const vm = this;
    // 離開前結束 websocket 監聽事件
    window.Echo.disconnect();
    const channelName = `one_to_one_${vm.sa_id}_${process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID}_${vm.user.member_uuid}`;
  }
};
</script>

<style lang="scss" scoped>

.chatroom__mainPart {
  padding-bottom: 70px;
}
</style>
